// extracted by mini-css-extract-plugin
export default {"main":"OpenStyle_main__gwQ1O"};